import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StateStatus } from '@guryou/redux';
import { getSessionsByClassId } from '../new/session';
const useSession = _ref => {
  let {
    classId,
    sessionId
  } = _ref;
  const dispatch = useDispatch();
  const {
    data,
    status,
    version,
    entity
  } = useSelector(state => state.sessions.all);
  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED || status === StateStatus.LOADED && data.length && data.every(x => x.classId !== classId)) {
      dispatch(getSessionsByClassId(classId));
    }
  }, [classId, data, dispatch, status]);
  return {
    session: (data || []).find(x => x.id === sessionId),
    status,
    version,
    entity
  };
};
export default useSession;